import { Box, BoxProps, Text } from '@chakra-ui/react';
import { IProfileLink } from '../../config/profileLinks';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Colors from '../../config/colors';

// export interface IProfileLink {
//     createIcon: () => React.ReactElement;
//     text: string;
//     borderColor?: string;
//     color?: string;
// }

interface Props extends BoxProps {
    profileLink: IProfileLink;
    closeModal: () => void;
    isActive: boolean;
}
export default function ProfileLink({ profileLink, isActive, closeModal, ...props }: Props) {
    const [t] = useTranslation();

    return (
        <Link to={profileLink.to} onClick={() => closeModal()}>
            <Box
                fontSize="16px"
                fontWeight="500"
                display="flex"
                alignItems="center"
                padding="0px 10px"
                justifyContent="space-between"
                width="100%"
                pointerEvents={'none'}
                color={isActive ? Colors.lightBlue : Colors.darkGrey}
                {...props}>
                {profileLink.createIcon()}
                <Text>{t(profileLink.localeName)}</Text>
            </Box>
        </Link>
    );
}
